import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f58103"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "matchSchedule" }
const _hoisted_2 = { class: "matchScheduleFull" }
const _hoisted_3 = { class: "center display-2" }
const _hoisted_4 = { class: "layout gutter--xl" }
const _hoisted_5 = { class: "row justify--space-around" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Pdf udskrift")
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Se stillingen")
const _hoisted_11 = { class: "va-table-responsive" }
const _hoisted_12 = { class: "va-table va-table--striped centerTable" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Kampnr", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Kampdato", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Ny Kampdato", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Hjemmehold", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Udehold", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "mobile" }, "Kommentar", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultat", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "colmatchnumb" }
const _hoisted_24 = { class: "colmatchorigdatetime" }
const _hoisted_25 = {
  key: 0,
  class: "colmatchchangedatetime"
}
const _hoisted_26 = { class: "colmatchnewdatetime" }
const _hoisted_27 = { class: "colmatchteamname" }
const _hoisted_28 = { class: "colmatchteamname" }
const _hoisted_29 = { class: "mobile colmatchcomment" }
const _hoisted_30 = { class: "center colmatchscores va-code-snippet" }
const _hoisted_31 = { class: "colmatchdetails" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_34 = { class: "matchScheduleMobile" }
const _hoisted_35 = { class: "center display-5" }
const _hoisted_36 = { class: "layout gutter--md" }
const _hoisted_37 = { class: "row justify--space-around mb-2" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Se stillingen")
const _hoisted_41 = { class: "row align--baseline" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Anmod om kampflytning")
const _hoisted_44 = { class: "center" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_47 = { class: "display-5 center" }
const _hoisted_48 = { class: "va-table-responsive" }
const _hoisted_49 = {
  class: "va-table va-table--striped rankingTable",
  style: {"width":"100%"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nr"),
    /*#__PURE__*/_createElementVNode("th", null, "Hold"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Kampe"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Uafgjorte"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Tabte"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Score"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Point")
  ])
], -1))
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { class: "center" }
const _hoisted_53 = { class: "center" }
const _hoisted_54 = { class: "center" }
const _hoisted_55 = { class: "center" }
const _hoisted_56 = { class: "center" }
const _hoisted_57 = { class: "layout gutter--xl" }
const _hoisted_58 = { class: "row justify--center" }
const _hoisted_59 = { class: "flex" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Anmod om kampflytning", -1))
const _hoisted_62 = {
  class: "layout gutter--md",
  style: {"height":"104px"}
}
const _hoisted_63 = { class: "row justify--center align--center" }
const _hoisted_64 = { class: "flex md3" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md3" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Anmoder om at kampen flyttes til:")
], -1))
const _hoisted_66 = { class: "flex md3" }
const _hoisted_67 = { class: "row justify--center" }
const _hoisted_68 = { class: "flex center" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Anmod om ny kampdato")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_71 = { class: "center display-4 mb-4 mt-4" }
const _hoisted_72 = { class: "va-table-responsive tableContainer" }
const _hoisted_73 = { class: "va-table va-table--striped tableItem" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kampnr."),
    /*#__PURE__*/_createElementVNode("th", null, "Kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Ny kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Hjemmehold"),
    /*#__PURE__*/_createElementVNode("th", null, "Udehold")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.seriesString + ', ' + _ctx.seasonString), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.teamFilterValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teamFilterValue) = $event)),
              options: _ctx.teamFilterOptions,
              "track-by": (v) => v.teamId,
              "text-by": (v) => v.teamName,
              label: "Filtrer efter hold",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_button, {
              color: "info",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRanking()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_13,
              _hoisted_14,
              (_ctx.mayChangeMatchDate())
                ? (_openBlock(), _createElementBlock("th", _hoisted_15))
                : _createCommentVNode("", true),
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSchedule, (match) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: Number(match.id),
                class: _normalizeClass(match.id === Number(_ctx.selectedMatch) && 'selectedMatch'),
                id: match.id === Number(_ctx.selectedMatch) && 'selectedMatchDesktop'
              }, [
                _createElementVNode("td", _hoisted_23, _toDisplayString(match.kampprogram_kampnr), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                (_ctx.mayChangeMatchDate())
                  ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                      _createVNode(_component_va_icon, {
                        name: _ctx.newMatchDatePossible(match.kampprogram_dato, match.kampprogram_nydato, match.kampprogram_hjemmehold.klubber_id, match.kampprogram_udehold.klubber_id) ? 'schedule_send' : '',
                        class: _normalizeClass({ reschedule: _ctx.newMatchDatePossible(match.kampprogram_dato, match.kampprogram_nydato, match.kampprogram_hjemmehold.klubber_id, match.kampprogram_udehold.klubber_id)}),
                        onClick: ($event: any) => ((_ctx.newMatchDatePossible(match.kampprogram_dato, match.kampprogram_nydato, match.kampprogram_hjemmehold.klubber_id, match.kampprogram_udehold.klubber_id) ? _ctx.makeRequest(Number(match.id), Number(match.kampprogram_hjemmehold.klubber_id), Number(match.kampprogram_udehold.klubber_id), new Date(match.kampprogram_dato)) : ''))
                      }, null, 8, ["name", "class", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_26, _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.getEnumComment(match.kampprogram_afb_udb) + (match.kampprogram_kommentar === null ? '' : (match.kampprogram_afb_udb === null ? match.kampprogram_kommentar : ' ; ' + match.kampprogram_kommentar))), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.getScores(Number(match.id))), 1),
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.setSelectedMatch(match))
                  }, [
                    _createVNode(_component_router_link, {
                      to: ('/turneringer/kampseddel/' + Number(match.id).toString())
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ], 8, _hoisted_32)
                ])
              ], 10, _hoisted_22))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.seriesString + ', ' + _ctx.seasonString), 1),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.teamFilterValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teamFilterValue) = $event)),
              options: _ctx.teamFilterOptions,
              "track-by": (v) => v.teamId,
              "text-by": (v) => v.teamName,
              label: "Filtrer efter hold",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_va_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getRanking()))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSchedule, (match) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex sm6 xs12",
              key: Number(match.id)
            }, [
              _createVNode(_component_va_card, {
                class: _normalizeClass(match.id === Number(_ctx.selectedMatch) && 'selectedMatch'),
                id: match.id === Number(_ctx.selectedMatch) && 'selectedMatchMobile'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_card_content, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, "Kampnr.: " + _toDisplayString(match.kampprogram_kampnr), 1),
                      _createElementVNode("p", null, "Kampdato: " + _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode("Ny kampdato: " + _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))) + " ", 1),
                        (_ctx.newMatchDatePossible(match.kampprogram_dato, match.kampprogram_nydato))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              _createVNode(_component_va_button, {
                                size: "small",
                                onClick: ($event: any) => ((_ctx.newMatchDatePossible(match.kampprogram_dato, match.kampprogram_nydato) ? _ctx.makeRequest(Number(match.id), match.kampprogram_hjemmehold, match.kampprogram_udehold) : ''))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", null, "Hjemmhold: " + _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                      _createElementVNode("p", null, "Udehold: " + _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1),
                      _createElementVNode("p", null, "Kommentar: " + _toDisplayString(_ctx.getEnumComment(match.kampprogram_afb_udb) + (match.kampprogram_kommentar === null ? '' : (match.kampprogram_afb_udb === null ? match.kampprogram_kommentar : ' ; ' + match.kampprogram_kommentar))), 1),
                      _createElementVNode("p", null, "Resultat: " + _toDisplayString(_ctx.getScores(Number(match.id))), 1),
                      _createElementVNode("p", _hoisted_44, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.setSelectedMatch(match))
                        }, [
                          _createVNode(_component_router_link, {
                            to: ('/turneringer/kampseddel/' + Number(match.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 8, _hoisted_45)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class", "id"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.rankingsModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rankingsModal) = $event)),
      width: "50%"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_47, _toDisplayString('Stillingen i ' + _ctx.seriesString), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("table", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamRankingsArray, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.teamName), 1),
                  _createElementVNode("td", _hoisted_51, _toDisplayString(item.matches), 1),
                  _createElementVNode("td", _hoisted_52, _toDisplayString(item.won), 1),
                  _createElementVNode("td", _hoisted_53, _toDisplayString(item.tied), 1),
                  _createElementVNode("td", _hoisted_54, _toDisplayString(item.lost), 1),
                  _createElementVNode("td", _hoisted_55, _toDisplayString(item.wonScore + '-' + item.lostScore), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(item.points), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rankingsModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_60
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.requestModal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestModal) = $event)),
      width: "50%"
    }, {
      header: _withCtx(() => [
        _hoisted_61
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_va_select, {
                modelValue: _ctx.requesteeValueString,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requesteeValueString) = $event)),
                options: _ctx.requesteeOptionsString,
                bordered: ""
              }, null, 8, ["modelValue", "options"])
            ]),
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_va_input, {
                type: "datetime-local",
                onChange: _ctx.validateMatchDate,
                max: _ctx.selectedMatchMaxDate,
                min: _ctx.selectedMatchMinDate,
                label: "Ny kampdato",
                modelValue: _ctx.newMatchDate,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newMatchDate) = $event)),
                bordered: "",
                class: "newMatchDate"
              }, null, 8, ["onChange", "max", "min", "modelValue"])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_va_button, {
              color: "success",
              class: "mr-2 mt-2",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.createNewMatchRequest()))
            }, {
              default: _withCtx(() => [
                _hoisted_69
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "secondary",
              class: "ml-2 mt-2",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.requestModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_70
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_vue3_html2pdf, {
      "show-layout": false,
      "float-layout": true,
      "preview-modal": true,
      "enable-download": false,
      "paginate-elements-by-height": 1400,
      filename: _ctx.seriesString + ', ' + _ctx.seasonString,
      "pdf-quality": 2,
      "manual-pagination": false,
      "pdf-format": "a4",
      "pdf-orientation": "portrait",
      "pdf-content-width": "100%",
      ref: "html2Pdf"
    }, {
      "pdf-content": _withCtx(() => [
        _createElementVNode("h4", _hoisted_71, _toDisplayString(_ctx.seriesString + ', ' + _ctx.seasonString), 1),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("table", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSchedule, (match) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: Number(match.id)
                }, [
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_kampnr), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["filename"])
  ]))
}